/* eslint-disable @typescript-eslint/no-explicit-any */
import { Popover } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

export interface DatePrefValue {
  id: number,
  date: string,
  [key: string]: any;
}

interface DatePreferenceFieldProps {
  value: DatePrefValue[]
  datePreference: 'earliest' | 'latest'
  sourceFormat: string
  targetFormat: string
  mapKey: string,
  map: Record<string, string>
}

export const DatePreferenceField: React.FC<DatePreferenceFieldProps> = React.memo((props) => {
  const {
    sourceFormat, targetFormat, value, mapKey, map, datePreference,
  } = props;

  const [date, setDate] = useState<DatePrefValue>();

  const dateCalc = () => {
    if (value.length === 0) return;
    if (datePreference === 'latest') {
      setDate(value.reduce((latest, current) => (dayjs(current.date).isAfter(dayjs(latest.date)) ? current : latest)));
    } else {
      setDate(value.reduce((earliest, current) => (dayjs(current.date).isAfter(dayjs(earliest.date)) ? current : earliest)));
    }
  };

  useEffect(() => {
    dateCalc();
  }, []);
  return (
    <Popover
      title={(
        <span style={{ textAlign: 'center' }}>{map[date?.[mapKey]]}</span>
      )}
      overlayStyle={{ minWidth: 70, maxWidth: 100 }}
    >
      {date?.date ? dayjs(date?.date, sourceFormat).format(targetFormat) : null}
    </Popover>
  );
});
